var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import gql from 'graphql-tag';
import { whereQuery } from '@/services/sharedForm';
import { BOLS, BOLS_AGG } from '@/queries/bols';
import FilterList from './FilterList.vue';
var WeightTotals = /** @class */ (function (_super) {
    __extends(WeightTotals, _super);
    function WeightTotals() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.bols = [];
        _this.bols_aggregate = null;
        _this.offset = 0;
        _this.where = {};
        _this.pageNum = 1;
        _this.sortDir = 'desc';
        _this.sortField = 'date';
        _this.hasError = false;
        _this.isInbound = false;
        _this.storageKey = 'outbound_filters';
        _this.loading = true;
        _this.options = {
            showSilo: true,
            showLocation: true,
            showProduct: true,
            showTimeframe: true,
            multiple: true,
            selectedSilo: [],
            selectedLocation: [],
            selectedProduct: [],
            selectedTimeframe: 'This Week',
            timeframeError: false,
            changeOptions: function () { return _this.filterChanged(); }
        };
        return _this;
    }
    WeightTotals.prototype.metaInfo = function () {
        return {
            title: this.$route.name
        };
    };
    WeightTotals.prototype.mounted = function () {
        this.isInbound = this.$route.name === 'Inbound Weight Total' ? true : false;
        this.storageKey = this.isInbound ? 'inbound_filters' : 'outbound_filters';
        var storedOptions = {};
        if (typeof (Storage) !== "undefined") {
            storedOptions = JSON.parse(localStorage.getItem(this.storageKey));
        }
        this.options = Object.assign(this.options, storedOptions);
        this.options.inboundOutbound = this.isInbound ? 'inbound' : 'outbound';
        this.where = whereQuery(this.options);
    };
    WeightTotals.prototype.beforeDestroy = function () {
        try {
            this.$apollo.subscriptions.bols.destroy();
            this.$apollo.subscriptions.bols_aggregate.destroy();
        }
        catch (e) { }
    };
    WeightTotals.prototype.onSort = function (field, order) {
        this.loading = true;
        this.sortDir = order;
    };
    WeightTotals.prototype.pageChanged = function (currPage) {
        this.loading = true;
        var offset = ((currPage - 1) * 25) + 1;
        this.offset = offset >= 0 ? offset : 0;
    };
    WeightTotals.prototype.filterChanged = function () {
        if (typeof (Storage) !== "undefined") {
            localStorage.setItem(this.storageKey, JSON.stringify(this.options));
        }
        this.loading = true;
        this.where = whereQuery(this.options);
    };
    WeightTotals = __decorate([
        Component({
            name: 'weight-totals',
            components: {
                'filter-list': FilterList
            },
            apollo: {
                bols: {
                    query: function () { return gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["query ", ""], ["query ", ""])), BOLS); },
                    variables: function () {
                        return {
                            offset: this.offset,
                            sort: this.sortDir,
                            where: this.where,
                        };
                    },
                    subscribeToMore: {
                        document: function () { return gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["subscription ", ""], ["subscription ", ""])), BOLS); },
                        variables: function () {
                            return {
                                offset: this.offset,
                                sort: this.sortDir,
                                where: this.where,
                            };
                        },
                        updateQuery: function (previousResult, _a) {
                            var subscriptionData = _a.subscriptionData;
                            return {
                                bols: subscriptionData.data.bols
                            };
                        }
                    },
                    result: function (_a) {
                        var data = _a.data;
                        this.loading = false;
                    }
                },
                bols_aggregate: {
                    query: function () { return gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["query ", ""], ["query ", ""])), BOLS_AGG); },
                    variables: function () {
                        return {
                            where: this.where,
                        };
                    },
                    subscribeToMore: {
                        document: function () { return gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["subscription ", ""], ["subscription ", ""])), BOLS_AGG); },
                        variables: function () {
                            return {
                                where: this.where,
                            };
                        },
                        updateQuery: function (previousResult, _a) {
                            var subscriptionData = _a.subscriptionData;
                            return {
                                bols_aggregate: subscriptionData.data.bols_aggregate
                            };
                        }
                    },
                }
            }
        })
    ], WeightTotals);
    return WeightTotals;
}(Vue));
export default WeightTotals;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/WeightTotals.vue
// module id = 791
// module chunks = 1